import MessageAlert from '../../../mixins/MessageAlert';
import Recaptcha from '../../../mixins/Recaptcha/Recaptcha.js';
import Loading from '../../../mixins/Loading';
import FormRules from '../../../mixins/Forms/FormRules';
export default {
  name: 'LandingForm',
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    }
  },
  mixins: [Recaptcha, MessageAlert, Loading, FormRules],
  data: () => {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        message: '',
        agreement: false,
        agreement2: false,
        agreement3: false
      },
      send: false
    };
  },
  computed: {
    agreements() {
      return this.$store.state.form_settings.agreements;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.Loading();
          await this.Recaptcha().then(async token => {
            const agree = [{
              text: this.agreements.agreement_1.replace(/(<([^>]+)>)/ig, ''),
              accepted: this.form.agreement
            }];
            if (this.agreements.agreement_2) {
              agree.push({
                text: this.agreements.agreement_2.replace(/(<([^>]+)>)/ig, ''),
                accepted: this.form.agreement2
              });
            }
            if (this.agreements.agreement_3) {
              agree.push({
                text: this.agreements.agreement_3.replace(/(<([^>]+)>)/ig, ''),
                accepted: this.form.agreement3
              });
            }
            await this.$axios.post('/wp-json/api/form/landing', {
              id: this.id,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone,
              body: this.form.message,
              agreements: agree
            }, {
              headers: {
                Token: token
              }
            }).then(async response => {
              this.MessageAlert({
                type: 'success',
                message: this.$t('form.notices.send_success'),
                duration: 5000
              });
              this.send = true;
              this.$refs[formName].resetFields();
            }).catch(e => {
              this.MessageAlert({
                type: 'error',
                message: this.$t('form.notices.send_error'),
                duration: 0,
                showClose: true
              });
            });
          });
          this.Loading();
        } else {
          return false;
        }
      });
    }
  }
};